import React, { lazy } from 'react';
import { tss } from 'tss-react/mui';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
const LiteYouTubeEmbed = lazy(() => import('react-lite-youtube-embed'));

interface Props {
  productName: string;
  youtubeLink: string;
}
export const YoutubeVideo: React.FC<Props> = ({ productName, youtubeLink }) => {
  const { classes, cx } = useStyles();
  const videoId = extractVideoID(youtubeLink);
  return videoId ? (
    <LiteYouTubeEmbed
      id={videoId}
      title={`Youtube content for ${productName}`}
      playerClass={cx('lty-playbtn', classes.player)}
      poster="sddefault"
    />
  ) : null;
};

const useStyles = tss.create({
  player: {
    border: 'none'
  }
});

export const extractVideoID = (url: string | URL) => {
  try {
    const urlObject = new URL(url);
    if (urlObject.hostname === 'youtu.be') {
      return urlObject.pathname.substring(1); // Remove leading '/'
    } else if (
      urlObject.hostname === 'www.youtube.com' &&
      urlObject.pathname === '/watch'
    ) {
      const searchParams = new URLSearchParams(urlObject.search);
      return searchParams.get('v');
    } else {
      // Check if it's a direct video link
      const parts = urlObject.pathname.split('/');
      if (parts.length === 2 && parts[1].length === 11) {
        return parts[1]; // Video ID directly follows the domain
      } else {
        return undefined; // Default video link
      }
    }
  } catch (_) {
    return undefined; // Default video link
  }
};
